import { FC, memo, useEffect } from 'react';
import { PickingList } from 'src/entities/pickingListEntity';
import { useQueryPickingList } from 'src/hooks/useQueryPickingList';

import LoadingComponent from './LoadingComponent';

export type PresenterProps = {
  models: PickingList[];
  date: string;
  unit: string;
}

type Props = {
  shiftIds: number[];
  date: string;
  presenter: FC<PresenterProps>;
  unit: string;
  onCountChange?: (count: number) => void;
}

function computePageCount(models: PickingList[]): number {
  return models.reduce((total, course) => {
    if (course.dispatches.length === 0) return total + 1;
    const courseCount = course.dispatches.reduce((dispatchTotal, loadingDate) => {
      const dateCount = loadingDate.shippers.reduce(
        (shipperTotal, shipper) => shipperTotal + shipper.unloads.length, 0
      );
      return dispatchTotal + dateCount;
    }, 0);
    return total + courseCount;
  }, 0);
}

const PickingListComponent: FC<Props> = memo(({ shiftIds, date, presenter: Presenter, unit, onCountChange }) => {
  const pickingQuery = useQueryPickingList(shiftIds);

  const count = pickingQuery.data ? computePageCount(pickingQuery.data) : 0;

  useEffect(() => {
    if (count > 0) onCountChange?.(count);
  }, [count, onCountChange]);

  if (pickingQuery.isLoading) {
    return <LoadingComponent />;
  }

  if (pickingQuery.isError) {
    return <>Error</>;
  }

  const pickigLists = pickingQuery.data;

  return <Presenter models={pickigLists} date={date} unit={unit} />;
});

export default PickingListComponent;
